
import { Vue } from "vue-property-decorator";
import _ from "lodash";

import { VueUserContextModel } from "@/core/models";

export default class AppVue extends Vue {
  notify(title: string, message: string, type: any) {
    this.$notify({
      title,
      message,
      type,
      duration: 10000, // give time for disable users to spot the message
    });
  }

  get userContext() {
    return this.$store.state.userContext as VueUserContextModel;
  }

  get isAuthenticated() {
    return this.$msal.isAuthenticated();
  }

  get email() {
    return this.userContext.email;
  }

  get currentUserId() {
    return this.userContext.userId;
  }

  get isAdmin() {
    return !!this.userContext.isAdmin;
  }

  get isUser() {
    return !!this.userContext.isUser;
  }

  get isDovetail() {
    return !!this.userContext.isDovetail;
  }

  get isImi() {
    return !!this.userContext.isImi;
  }

  get isEi() {
    return !!this.userContext.isEi;
  }

  get environment() {
    return process.env.VUE_APP_ENVIRONMENT;
  }

  get isDevEnv() {
    return this.environment === "Dev";
  }

  get isTestEnv() {
    return this.environment === "Test";
  }

  get isProdEnv() {
    return this.environment === "Production";
  }
}
